import { LinearProgress } from "../LinearProgress";

export function LoadingOverlay() {
  return (
    <div className="flex h-full w-full items-end">
      <LinearProgress />
    </div>
  );
}
